import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";

const initialValues = {
    serviceId: "00000000-0000-0000-0000-000000000000",
    title: "",
    description: "",
    services: ""
};

export default function ServiceSection() {
    const [values, setValues] = useState(initialValues);
    const [isEditMode, setIsEditMode] = useState(false);
    const [originalData, setOriginalData] = useState(null);

    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken")
        }
    };

    useEffect(() => {
        getService();
    }, []);

    const getService = () => {
        axios.get(config.APIACTIVATEURL + config.GETSERVICES, headerconfig)
            .then(res => {
                if (res.data.data.length > 0) {
                    const serviceData = res.data.data[0];
                    serviceData.services = Array.isArray(serviceData.services)
                        ? serviceData.services.join(", ")
                        : serviceData.services;
                    setValues(serviceData);
                    setOriginalData(serviceData);
                }
            })
            .catch(err => console.log(err));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = {
            ...values,
            updatedDate: new Date().toISOString()
        };

        axios.put(
            `${config.APIACTIVATEURL}${config.UPDATESERVICE}/${values.serviceId}`,
            payload,
            headerconfig
        )
            .then(res => {
                if (res.data.statusCode === 200) {
                    handleSuccess("Service Updated");
                    setIsEditMode(false);
                    getService();
                } else {
                    handleError(res.data.message);
                }
            })
            .catch(err => {
                console.error(err);
                handleError("Update failed");
            });
    };

    const handleCancel = () => {
        setValues(originalData);
        setIsEditMode(false);
    };

    return (
         <div id="layout-wrapper">
                <Header />
                <SideBar />
                <div className="vertical-overlay" />
            
                {/* Use the same structure as your working screen */}
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid"></div>
        <div className="container">
            {/* Preview Section */}
            <div className="text-center mb-3">
                <h2 className="mb-3 fw-semibold lh-base">{values.title}</h2>
                <p className="text-black fs-4">{values.description}</p>

                {/* Services Grid */}
                {values.services && typeof values.services === 'string' && (
                    <div className="pt-2 pb-2">
                        {values.services.split(",").reduce((rows, service, index, allServices) => {
                            if (index % 3 === 0) {
                                rows.push(allServices.slice(index, index + 3));
                            }
                            return rows;
                        }, []).map((row, rowIndex) => (
                            <div className="row mb-3 justify-content-start" key={rowIndex}>
                                {row.map((service, colIndex) => (
                                    <div className="col-md-4" key={colIndex}>
                                        <ul className="list-group">
                                            <li className="list-group-item d-flex align-items-center text-black">
                                                <iconify-icon
                                                    className="text-success me-2"
                                                    icon="material-symbols:thumb-up-outline"
                                                    width="24"
                                                    height="24"
                                                ></iconify-icon>
                                                {service.trim()}
                                            </li>
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <hr style={{ border: "3px solid black", margin: "40px 0" }} />

            {/* Form Section */}
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Service Section Details</h4>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Title</label>
                                        <textarea
                                            name="title"
                                            value={values.title}
                                            onChange={handleInputChange}
                                            className="form-control"
                                            rows={1}
                                            readOnly={!isEditMode}
                                        />
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Description</label>
                                        <textarea
                                            name="description"
                                            value={values.description}
                                            onChange={handleInputChange}
                                            className="form-control"
                                            rows={2}
                                            readOnly={!isEditMode}
                                        />
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Services</label>
                                        <textarea
                                            name="services"
                                            value={values.services}
                                            onChange={handleInputChange}
                                            className="form-control"
                                            rows={2}
                                            placeholder="Enter comma-separated services"
                                            readOnly={!isEditMode}
                                        />
                                    </div>

                                    {/* Buttons shown only in edit mode */}
                                    {isEditMode && (
                                        <div className="col-12 mt-3 d-flex justify-content-end gap-2">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={handleCancel}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                            >
                                                Save Changes
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Button below form */}
            {!isEditMode && (
                <div className="d-flex justify-content-end mt-3">
                    <button
                        className="btn btn-warning"
                        onClick={() => setIsEditMode(true)}
                    >
                        Edit
                    </button>
                </div>
            )}
        </div>
        </div>
        </div>
        </div>
    );
}
